function* controlsAt(controls, pathPrefix, scope, appliedTo) {
    if (!controls) {
        return;
    }
    for (const [controlId, control] of Object.entries(controls.data)) {
        yield { pathPrefix, scope, appliedTo, controlId, control };
    }
}
/**
 * Enumerate every control in an architecture across all scopes in document order:
 * top-level, then nodes, then relationships, then flows.
 */
export function* iterateControls(architecture) {
    yield* controlsAt(architecture.controls, '/controls', 'Architecture', '');
    for (let nodeIdx = 0; nodeIdx < architecture.nodes.length; nodeIdx++) {
        const node = architecture.nodes[nodeIdx];
        yield* controlsAt(node.controls, `/nodes/${nodeIdx}/controls`, 'Node', node.uniqueId);
    }
    for (let relIdx = 0; relIdx < architecture.relationships.length; relIdx++) {
        const relationship = architecture.relationships[relIdx];
        yield* controlsAt(relationship.controls, `/relationships/${relIdx}/controls`, 'Relationship', relationship.uniqueId);
    }
    const flows = architecture.flows ?? [];
    for (let flowIdx = 0; flowIdx < flows.length; flowIdx++) {
        const flow = flows[flowIdx];
        yield* controlsAt(flow.controls, `/flows/${flowIdx}/controls`, 'Flow', flow.uniqueId);
    }
}
//# sourceMappingURL=control-iteration.js.map